import { SourceType } from '@wix/answers-api';
import { useCallback } from 'react';

import useIsKbServiceEnabled from './useIsKbServiceEnabled';
import { answersApi } from '../utils/answers';
import {
  followArticleRequest,
  isFollowingArticleRequest,
  unfollowArticleRequest,
} from '../utils/article-follow-client';
import { useStore } from '../zustand/stores';

export const useArticleFollow = () => {
  const { isWixStudioUser } = useStore((state) => state.userSlice);
  const useKbService = useIsKbServiceEnabled();

  const checkIsFollowing = useCallback(
    (id: string, locale: string): Promise<boolean> => {
      if (useKbService) {
        return isFollowingArticleRequest(id, locale);
      }
      return answersApi.articles.isFollowingArticle({ id, locale });
    },
    [useKbService]
  );

  const follow = useCallback(
    (id: string, locale: string): Promise<unknown> => {
      if (useKbService) {
        return followArticleRequest(id, locale);
      }
      return answersApi.articles.voteOnIssueOrFeature({
        sourceId: null,
        locale,
        id,
        sourceType: SourceType.HELP_CENTER,
        isProUser: isWixStudioUser,
      });
    },
    [useKbService, isWixStudioUser]
  );

  const unfollow = useCallback(
    (id: string, locale: string): Promise<unknown> => {
      if (useKbService) {
        return unfollowArticleRequest(id, locale);
      }
      return answersApi.articles.unvoteOnIssueOrFeature({
        sourceId: null,
        locale,
        id,
        sourceType: SourceType.HELP_CENTER,
        isProUser: isWixStudioUser,
      });
    },
    [useKbService, isWixStudioUser]
  );

  return { checkIsFollowing, follow, unfollow };
};
